'use client';

import Link from 'next/link';
import { signIn } from 'next-auth/react';
import { useState } from 'react';
import { motion } from 'framer-motion';

export default function Page() {
  const [isLoading, setIsLoading] = useState(false);
  const [allowGoogleLogin, setAllowGoogleLogin] = useState(false);

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      await signIn('google', { callbackUrl: '/chat' });
    } catch (error) {
      console.error('Google sign in error:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-1 w-full items-start pt-12 md:pt-0 md:items-center justify-center bg-background">
      <div className="w-full max-w-md overflow-hidden rounded-2xl flex flex-col gap-8 px-4 sm:px-16">
        <motion.div className="flex justify-center">
          <motion.img
            src={`/images/rowmantic-logo-trans.png`}
            alt={'rowmantic.com logo'}
            className="w-[350px]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.2,
            }}
          />
        </motion.div>

        <div className="flex flex-col items-center justify-center gap-2 text-center">
          <h3 className="text-xl font-semibold dark:text-zinc-50">Sign In</h3>
          <p className="text-sm text-gray-500 dark:text-zinc-400">
            {/* Sign in with your Google account to get started */}
            Google login is disabled during the trial.
          </p>
        </div>

        <div className="flex flex-col gap-4">
          <button
            onClick={handleGoogleSignIn}
            disabled={!allowGoogleLogin || isLoading}
            className="flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 dark:border-zinc-700 rounded-lg hover:bg-gray-50 dark:hover:bg-zinc-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            {isLoading ? 'Signing in...' : 'Continue with Google'}
          </button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300 dark:border-zinc-700" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-background text-gray-500 dark:text-zinc-400">
                or
              </span>
            </div>
          </div>

          <Link
            href="/guest-login"
            className="flex items-center justify-center px-4 py-3 border border-gray-300 dark:border-zinc-700 rounded-lg hover:bg-gray-50 dark:hover:bg-zinc-800 transition-colors text-center"
          >
            Try as Guest
          </Link>
        </div>

        <p className="text-center text-xs text-gray-500 dark:text-zinc-400">
          By{' '}
          <span
            onClick={() => setAllowGoogleLogin(true)}
            className="cursor-default"
          >
            signing in
          </span>
          , you agree to our Terms of Service and{' '}
          <Link
            href="/privacy-policy"
            className="underline hover:text-foreground"
          >
            Privacy Policy
          </Link>
        </p>
      </div>
    </div>
  );
}
